import React from 'react';
import { useParams } from 'react-router-dom';
import {
	Card,
	Col,
	Row,
} from 'antd';
import { FixtureTypes } from '@shared/utils/constants';
import { CentralStoreProvider } from '@client/screens/estimates/details/context/CentralStoreContext';
import CargoProvider from '@client/screens/estimates/details/context/CargoContext';
import TcTermsModalContent from '@client/screens/estimates/details/TcTermsModalContent';
import Modal from '@client/components/Modal/Modal';
import TcContractDetailsScreen from './TcContractDetailsScreen';
import VcContractDetailsScreen from './VcContractDetailsScreen';
import {
	useVoyage,
	VoyageProvider,
} from './components/VoyageProvider/VoyageProvider';
import ContractLoading from './components/VoyageProvider/components/ContractLoading';

const ContractDetailsContent = () => {
	const {
		voyageDetails,
		voyageDetailsLoading,
		fixtureCurrency,
		showTcTermsModal,
		setShowTcTermsModal,
		refreshDetails,
		tcFixtureDetails,
	} = useVoyage();

	const fixtureType = voyageDetails?.fixture?.type;

	if (voyageDetailsLoading) {
		return (
			<Row gutter={[16, 16]} align="middle" justify="center">
				<Col span={12}>
					<div style={{ padding: 16 }}>
						<Card title="Loading">
							Contract is loading
							<br />
							Please wait
						</Card>
					</div>
				</Col>
			</Row>
		);
	}

	if (voyageDetails == null || fixtureCurrency == null) {
		return (
			<ContractLoading />
		);
	}

	if (voyageDetails && fixtureCurrency) {
		if (fixtureType === FixtureTypes.SPOT) {
			return (
				<VcContractDetailsScreen />
			);
		}

		return (
			<>
				<TcContractDetailsScreen />
				<Modal
					onCancel={() => setShowTcTermsModal(false)}
					width="80%"
					open={showTcTermsModal}
					closeIcon={false}
					footer={null}
				>
					<TcTermsModalContent
						bunkers={voyageDetails.voyageBunkers}
						fixtureDetails={tcFixtureDetails}
						tcTerms={voyageDetails.tcTerms}
						voyageDetails={voyageDetails}
						availableFuelGrades={voyageDetails.vesselFuelGrades}
						fixtureCurrency={fixtureCurrency}
						refreshDetails={refreshDetails}
						open={showTcTermsModal}
						onClose={() => setShowTcTermsModal(false)}
					/>
				</Modal>
			</>
		);
	}

	return null;
};

const ContractDetailsScreen = () => {
	const { id } = useParams<{ id: string }>();

	return (
		<VoyageProvider key={id} voyageId={Number(id)}>
			<CentralStoreProvider>
				<CargoProvider>
					<ContractDetailsContent />
				</CargoProvider>
			</CentralStoreProvider>
		</VoyageProvider>
	);
};

export default ContractDetailsScreen;
